import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import {BrowserRouter as Router} from "react-router-dom";
import App from './App';
import ErrorBoundary from './Components/ErrorBoundary';
import './index.css';

// Sentry initialization
Sentry.init({
    dsn: 'https://75c03c5d99524030f37cb07c12a44ff6@s.unlimco.io/3',
    environment: process.env.NODE_ENV || 'production',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.2,
        beforeSend: function(event) {
            // Don't send events for 401 errors (expected auth flow)
            if (event.exception && event.exception.values) {
                var isAuthError = event.exception.values.some(
                    function(v) { return v.value && v.value.includes('401'); }
                );
                if (isAuthError) return null;
            }
            return event;
        },
    });

// Expose Sentry globally for debugging
window.Sentry = Sentry;

ReactDOM.render(
    <ErrorBoundary>
        <Router>
            <App/>
        </Router>
    </ErrorBoundary>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js